// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScenarioTableFilters_wrapper__2l2TV","inner":"ScenarioTableFilters_inner__2vO85","title":"ScenarioTableFilters_title__tSVw0"};